/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Teams_Create_Team_Name_MinInputs */



/**
* | output |
* | --- |
* | "Team name must be at least {count} characters" |
*
* @param {Teams_Create_Team_Name_MinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_create_team_name_min = /** @type {((inputs: Teams_Create_Team_Name_MinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Create_Team_Name_MinInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Teamname muss mindestens ${i?.count} Zeichen lang sein`)
	return /** @type {LocalizedString} */ (`Team name must be at least ${i?.count} characters`)
});